// src/redux/rootReducer.js

import { combineReducers } from "redux";
import productsSlice from "./slices/productsSlice";
import estimatesSlice from "./slices/estimatesSlice";
import currentEstimateSlice from "./slices/currentEstimate";
import authSlice from "./slices/authSlice";
import templatesSlice from "./slices/templatesSlice";
import clinicsSlice from "./slices/clinicsSlice";
import subsidiesSlice from "./slices/subsidiesSlice";


const rootReducer = combineReducers({
  currentEstimate: currentEstimateSlice,
  products: productsSlice,
  estimates: estimatesSlice,
  auth: authSlice,
  templates: templatesSlice,
  clinics: clinicsSlice,
  subsidies: subsidiesSlice,
});

export default rootReducer;
